import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { enableDisableProposalAction } from "../../store/actions/proposalActions";
import { uploadBulkDisable } from "../../store/actions/fileUploadActions";
import DataTable from "../../components/Table";
import { toaster } from "../../utils/utils";

const EnableProposal = () => {
  const [proposalNumber, setProposalNumber] = useState("");
  const [enableData, setEnableData] = useState("");
  const dispatch = useDispatch();

  const triggerUploadCSV = () => {
    document.getElementById("enable-csv-upload").click();
  };

  const enableProposal = useCallback(() => {
    const disable = false;
    dispatch(
      enableDisableProposalAction(proposalNumber, disable, (data) => {
        const { body } = data;
        if (body) {
          const enableResult = [body];
          setEnableData(enableResult);
        }
      })
    );
  }, [proposalNumber, dispatch]);

  const enableAllProposal = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("disableProposal", false);
    dispatch(
      uploadBulkDisable(formData, (data) => {
        const {
          data: { body },
        } = data;
        if (body) {
          const value = [];
          body.forEach((item) => {
            value.push({
              ...item,
              disbaledStatus:
                item.remarks === "Proposal Does Not Exist"
                  ? item.disbaledStatus
                  : !item.disbaledStatus,
            });
          });
          setEnableData(value);
        }
      })
    );
  };

  return (
    <>
      <div className="disable-enable-proposal-page__panel">
        <div className="disable-enable-proposal-page__controls-row">
          <button
            type="button"
            className="disable-enable-proposal-page__btn disable-enable-proposal-page__btn--primary"
            onClick={triggerUploadCSV}
          >
            Upload All
          </button>
          <input
            id="enable-csv-upload"
            className="disable-enable-proposal-page__file-input"
            type="file"
            name="file"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={(e) => {
              if (
                e.target.files &&
                e.target.files.length &&
                e.target.files[0].size / 1000 / 1000 > 10
              ) {
                return toaster(
                  "warn",
                  "Selected file size cannot be greater than 10 mb."
                );
              }
              if (e.target.files && e.target.files.length) {
                enableAllProposal(e.target.files[0]);
              }
            }}
            onClick={(e) => {
              e.target.value = null;
            }}
          />
        </div>

        <div className="disable-enable-proposal-page__controls-row">
          <div className="disable-enable-proposal-page__field">
            <label
              className="disable-enable-proposal-page__label"
              htmlFor="enable-proposal-number"
            >
              Proposal Number
            </label>
            <input
              id="enable-proposal-number"
              name="proposalNumber"
              value={proposalNumber}
              onChange={(e) => setProposalNumber(e.target.value)}
              className="disable-enable-proposal-page__input"
              type="text"
              placeholder="Enter Proposal Number"
            />
          </div>
          <button
            type="button"
            className="disable-enable-proposal-page__btn disable-enable-proposal-page__btn--primary"
            onClick={enableProposal}
          >
            Submit
          </button>
        </div>
      </div>

      {enableData && (
        <div className="proposal-dashboard__table-section disable-enable-proposal-page__table-section">
          <DataTable
            cellHeaders={["Proposal Number", "Remarks", "Enabled Status"]}
            data={enableData}
            keys={["proposalNumber", "remarks", "disbaledStatus"]}
            fileName="enable"
            addSerialNo={true}
            showExcelDownload={true}
            PerPageApiData={false}
            paginationItems={enableData}
            alwaysShown={false}
            convertValueToString={true}
          />
        </div>
      )}
    </>
  );
};

export default EnableProposal;
